import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { TablePluginOptions } from '../table/types';
import { renderReadOnlyTable } from './components/AdminView/renderReadOnlyTable';

const defaultOptions: TablePluginOptions = {
  stickyHeaderOffset: 0,
};

export const BlogTableReadOnlyPlugin = (opts: TablePluginOptions = {}): SlatePlugin => {
  const options = { ...defaultOptions, ...opts };

  return {
    renderElement: renderReadOnlyTable(options),
  };
};
